import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import { makeStyles } from "@mui/styles";
import Alert from "@mui/material/Alert";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { setSnackbar } from "../api/snackbar";
const useStyles = makeStyles((theme) => ({
  root: {},
}));

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} value={props.value} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" style={{ color: "white", fontSize: "14px" }}>{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

// Safe Transition component that doesn't access scrollTop
// This prevents errors when the container becomes null during dialog unmount
const SafeTransition = React.forwardRef(function SafeTransition(props, ref) {
  const { in: inProp, children } = props;
  
  // Simple fade-in without accessing scrollTop
  const [opacity, setOpacity] = React.useState(0);
  
  React.useEffect(() => {
    if (inProp) {
      // Use requestAnimationFrame to avoid accessing scrollTop
      requestAnimationFrame(() => {
        setOpacity(1);
      });
    } else {
      setOpacity(0);
    }
  }, [inProp]);
  
  return (
    <div
      ref={ref}
      style={{
        opacity: opacity,
        transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      }}
    >
      {children}
    </div>
  );
});

const CustomizedSnackbars = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const snackbarOpen = useSelector((state) => state.snackbar.snackbarOpen);
  const snackbarType = useSelector((state) => state.snackbar.snackbarType);
  const completedItems = useSelector((state) => state.snackbar.completedItems);
  const totalItems = useSelector((state) => state.snackbar.totalItems);
  const snackbarMessage = useSelector(
    (state) => state.snackbar.snackbarMessage
  );
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setSnackbar(false, snackbarType, snackbarMessage));
  };
  var progress = 0;
  if (snackbarType == "loading") {
    progress = (completedItems / totalItems) * 100
  }
  // Ensure container always returns a valid element
  // Use a ref to ensure we always have document.body available
  const containerRef = React.useRef(null);
  React.useEffect(() => {
    containerRef.current = document.body;
  }, []);

  const getContainer = () => {
    return containerRef.current || document.body || document.documentElement;
  };

  return (
    <div className={classes.root}>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={snackbarType === "warning" && !snackbarMessage.includes("Loading") ? 3000 : 20000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        container={getContainer}
        TransitionComponent={SafeTransition}
        disablePortal={false}
      >
        {snackbarType == "loading" ?
          <Alert
            elevation={6}
            variant="filled"
            onClose={handleClose}
            severity={"warning"}
            style={{ color: "white", fontSize: "14px" }}
          >
            {`${snackbarMessage}  ${completedItems}/${totalItems}`}
            <LinearProgressWithLabel
              value={progress}
            />
          </Alert>
          :
          <Alert
            elevation={6}
            variant="filled"
            onClose={handleClose}
            severity={snackbarType}
            style={{ color: "white", fontSize: "14px" }}
          >
            {snackbarType === "warning" && snackbarMessage.includes("Loading") && <CircularProgress size={20} />}
            {snackbarMessage}
          </Alert>
        }
      </Snackbar>
    </div>
  );
};

export default CustomizedSnackbars;
